"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeTableGridDisplay = void 0;
const lodash_1 = __importDefault(require("lodash"));
const GridDisplay_1 = require("./GridDisplay");
const _1 = require(".");
class FreeTableGridDisplay extends GridDisplay_1.GridDisplay {
    constructor(model, config, setConfig, cache, setCache) {
        var _a;
        super(config, setConfig, cache, setCache);
        this.model = model;
        this.columns = ((_a = model === null || model === void 0 ? void 0 : model.structure) === null || _a === void 0 ? void 0 : _a.__isDynamicStructure)
            ? (0, _1.analyseCollectionDisplayColumns)(model === null || model === void 0 ? void 0 : model.rows, this)
            : this.getDisplayColumns(model);
        this.filterable = false;
        this.sortable = false;
    }
    getDisplayColumns(model) {
        var _a, _b, _c;
        return lodash_1.default.uniqBy(((_c = (_b = (_a = model === null || model === void 0 ? void 0 : model.structure) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.map(col => this.getDisplayColumn(col))) === null || _c === void 0 ? void 0 : _c.map(col => (Object.assign(Object.assign({}, col), { isChecked: this.isColumnChecked(col) })))) || [], col => col.uniqueName);
    }
    getDisplayColumn(col) {
        const uniquePath = [col.columnName];
        const uniqueName = uniquePath.join('.');
        return Object.assign(Object.assign({}, col), { pureName: 'data', schemaName: '', headerText: col.columnName, uniqueName,
            uniquePath });
    }
}
exports.FreeTableGridDisplay = FreeTableGridDisplay;
